module.exports = __webpack_public_path__ + "static/img/przybornik_wielkosc7.b3c6e058.png";